<template>
    <section id="hotel" class="section py-20 bg-zinc-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex flex-col lg:flex-row items-center">
                <!-- Texto lateral -->
                <div class="lg:w-1/2 mb-10 lg:mb-0 lg:pr-10">
                    <h2 class="text-3xl md:text-4xl font-bold text-zinc-700 mb-6">Conforto e Elegância</h2>
                    <p class="text-lg text-zinc-600 mb-6">Nossas suítes exclusivas combinam o melhor do design contemporâneo com materiais naturais.</p>
                    <p class="text-lg text-zinc-600 mb-8">Desde os lençóis de algodão egípcio até as varandas privativas com vista para a paisagem.</p>
                    <div class="grid grid-cols-2 gap-4 mb-10">
                        <div class="flex items-center">
                            <i class="fas fa-wifi text-primary text-xl mr-3"></i>
                            <span>Wi-Fi de alta velocidade</span>
                        </div>
                        <div class="flex items-center">
                            <i class="fas fa-swimming-pool text-primary text-xl mr-3"></i>
                            <span>Piscina infinita</span>
                        </div>
                        <div class="flex items-center">
                            <i class="fas fa-spa text-primary text-xl mr-3"></i>
                            <span>Spa premium</span>
                        </div>
                        <div class="flex items-center">
                            <i class="fas fa-concierge-bell text-primary text-xl mr-3"></i>
                            <span>Serviço 24h</span>
                        </div>
                    </div>
                    <div class="bg-black/20 backdrop-blur-sm p-6 rounded-lg">
                        <div class="flex items-center mb-4">
                            <i class="fa-solid fa-umbrella-beach text-zinc-700 text-xl mr-3"></i>
                            <span class="text-zinc-700 font-semibold">Estadia Inesquecível</span>
                        </div>
                        <p class="text-zinc-700">Relaxe com conforto e exclusividade em meio à natureza, com serviços de alto padrão.</p>
                    </div>
                </div>

                <!-- Carrossel -->
                <div class="lg:w-1/2">
                    <Swiper :modules="[EffectCards, Autoplay]" effect="cards" :loop="images.length > 1" :autoplay="images.length > 1 ? { delay: 3000, disableOnInteraction: false } : false" grab-cursor class="w-full p-4 bg-transparent">
                        <SwiperSlide v-for="(image, index) in images" :key="index" class="overflow-visible">
                            <img :src="image.src" :alt="image.alt" class="w-full h-72 object-cover rounded-lg shadow-lg transition-transform duration-300 ease-in-out hover:scale-110 hover:z-10 will-change-transform" style="transform-origin: center center;" />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>

            <!-- Ícones -->
            <div class="grid md:grid-cols-3 gap-8 mt-12">
                <div class="text-center">
                    <div class="bg-primaryLight text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-bed text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-zinc-700 mb-3">Conforto e Sofisticação</h3>
                    <p class="text-zinc-600">Acomodações espaçosas com decoração elegante, climatização e enxoval premium.</p>
                </div>
                <div class="text-center">
                    <div class="bg-primaryLight text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-spa text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-zinc-700 mb-3">Serviços Exclusivos</h3>
                    <p class="text-zinc-600">Spa, room service, café da manhã artesanal e atendimento personalizado.</p>
                </div>
                <div class="text-center">
                    <div class="bg-primaryLight text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-swimming-pool text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-zinc-700 mb-3">Lazer para Toda a Família</h3>
                    <p class="text-zinc-600">Piscinas, salas de jogos, áreas kids e atividades para todas as idades.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { EffectCards, Autoplay } from 'swiper/modules';

const images = [
    { src: new URL('../../assets/images/bg/resort-main.jpg', import.meta.url).href, alt: 'Adega de vinhos' },
    { src: new URL('../../assets/images/bg/resort-main2.jpg', import.meta.url).href, alt: 'Taças de vinho' },
    { src: new URL('../../assets/images/bg/resort-main3.jpg', import.meta.url).href, alt: 'Degustação de vinho' },
    { src: new URL('../../assets/images/bg/resort-main4.jpg', import.meta.url).href, alt: 'Garrafas de vinho' },
    { src: new URL('../../assets/images/bg/resort-main2.jpg', import.meta.url).href, alt: 'Vista panorâmica' },
    { src: new URL('../../assets/images/bg/resort-main.jpg', import.meta.url).href, alt: 'Área de lazer' },
];
</script>
